module.exports = "//public.getcloudapp.com/packs/media/images/slack-icon-ce84fe715cf07adf2cad08b28db7401f.png";